import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M20 11.3307L7 18.8363L7 3.82518L20 11.3307Z" }));
const ForwardRef = forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };
